var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"copy-context",class:{ 'copy-context--visible': _vm.visible }},_vm._l((_vm.items),function(item,index){return _c('div',{key:index,staticClass:"copy-context__item",on:{"click":function($event){$event.stopPropagation();return _vm.invokeAction(item.action)}}},[_vm._v(" "+_vm._s(item.label)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }